import React, { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { Placeholder } from 'react-bootstrap';
 
const Protected = () => {

    const { isAuth } = useAuth();

    if (!isAuth) {
        return <Navigate to="/login" replace />
    }

    return (
        <Suspense fallback={<Placeholder />}>
            <Outlet />
        </Suspense>
    )
}

export default Protected
